import { Check } from "lucide-react";
import { Separator } from "../ui/separator";

export default function OrderSummary({
  selectedPlan = "plus",
  billingMode = "monthly",
}) {
  const pricingData = {
    basic: {
      monthly: {
        price: 8,
        features: ["Access to all basic features", "5 Documents"],
      },
      yearly: {
        price: 80,
        features: ["Access to all basic features", "5 Documents"],
      },
    },
    standard: {
      monthly: {
        price: 12,
        features: ["Access to all basic features", "12 Documents"],
      },
      yearly: {
        price: 120,
        features: ["Access to all basic features", "12 Documents"],
      },
    },
    plus: {
      monthly: {
        price: 24,
        features: [
          "Access to all basic features",
          "25 Documents",
          "Priority support",
          "Advanced analytics",
        ],
      },
      yearly: {
        price: 240,
        features: [
          "Access to all basic features",
          "25 Documents",
          "Priority support",
          "Advanced analytics",
        ],
      },
    },
    pro: {
      monthly: {
        price: 49,
        features: [
          "Access to all basic features",
          "25+ Documents",
          "Team collaboration",
          "Admin controls",
        ],
      },
      yearly: {
        price: 490,
        features: [
          "Access to all basic features",
          "25+ Documents",
          "Team collaboration",
          "Admin controls",
        ],
      },
    },
  };

  const planKey = selectedPlan.toLowerCase();
  const planData = pricingData[planKey]?.[billingMode];
  const planLabel = planKey.charAt(0).toUpperCase() + planKey.slice(1);
  const isMonthly = billingMode === "monthly";

  if (!planData) {
    return <div className="text-red-600">Invalid plan selected.</div>;
  }

  const { price, features } = planData;
  const tax = +(price * 0.08).toFixed(2);
  const total = +(price + tax).toFixed(2);

  return (
    <div className="top-6 sticky bg-green-50 p-6 border border-green-100 rounded-xl">
      <h3 className="mb-4 font-semibold text-green-800 text-xl">
        Order Summary
      </h3>

      <div className="bg-white mb-6 p-4 border border-green-100 rounded-lg">
        <div className="flex justify-between items-center mb-2">
          <h4 className="font-semibold text-green-700 text-lg">
            {planLabel} Plan
          </h4>
          <div className="bg-green-500 px-3 py-1 rounded-full font-medium text-white text-xs">
            Selected
          </div>
        </div>

        <p className="mb-4 text-gray-600 text-sm">
          Billed {isMonthly ? "monthly" : "yearly"}
        </p>

        <ul className="space-y-2 mb-4">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start text-sm">
              <Check className="flex-shrink-0 mt-0.5 mr-2 w-4 h-4 text-green-500" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>

        <div className="font-bold text-green-700 text-2xl">
          ${price}/{isMonthly ? "month" : "year"}
        </div>
      </div>

      <div className="space-y-3 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">Subtotal</span>
          <span className="font-medium">${price.toFixed(2)}</span>
        </div>


        <Separator className="my-3" />

        <div className="flex justify-between font-semibold text-base">
          <span>Total</span>
          <span className="text-green-700">${total.toFixed(2)}</span>
        </div>

        <div className="flex justify-between mt-1 text-gray-500 text-xs">
          <span>Billed {isMonthly ? "monthly" : "yearly"}</span>
        </div>
      </div>

      <div className="mt-6 text-gray-500 text-xs">
        <p>
          By completing your purchase, you agree to our{" "}
          <a href="#" className="text-green-600 hover:underline">
            Terms of Service
          </a>{" "}
          and{" "}
          <a href="#" className="text-green-600 hover:underline">
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </div>
  );
}
